var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftRightSolid = function SvgLeftRightSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25M5.313 14.688a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876m0-3.75a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876m0-3.75a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875M15 14.375H8.125a.625.625 0 1 1 0-1.25H15a.624.624 0 1 1 0 1.25m0-3.75H8.125a.625.625 0 1 1 0-1.25H15a.625.625 0 1 1 0 1.25m0-3.75H8.125a.625.625 0 0 1 0-1.25H15a.625.625 0 1 1 0 1.25"
  })));
};
export default SvgLeftRightSolid;